import { Text, Inline, Badge } from 'braid-design-system';
import { FilterButton } from './FilterButton';
import { useTranslations } from '@vocab/react';
import translations from './.vocab';

interface FilterActionButtonProps {
  selectedFilterCount: number;
  openFilterDrawer: () => void;
}

export const FilterActionButton: React.FC<FilterActionButtonProps> = ({
  selectedFilterCount,
  openFilterDrawer,
}) => {
  const { t } = useTranslations(translations);
  return (
    <FilterButton onClick={() => openFilterDrawer()}>
      <Inline space="small" alignY="center">
        <Text maxLines={1} size="small" baseline={false} weight="medium">
          {t('Filter and search')}
        </Text>
        {selectedFilterCount > 0 && (
          <Badge tone="neutral">{selectedFilterCount}</Badge>
        )}
      </Inline>
    </FilterButton>
  );
};
